@if ((errorList$ | async).length>0) {
  <span class="error-message">
    <span class="error-icon">
      <rask-icon [autoClose]="false" icon="fal fa-exclamation-circle" text="">
        <p>Det uppstod problem vid laddning av följande lager i kartan:</p>
        <ul>
          @for (item of errorList$|async; track item) {
            <li>{{item}}</li>
          }
        </ul>
      </rask-icon>
    </span>
    <span class="error-message-text">Vissa kartlager är inte tillgängliga</span>
  </span>
}